import { Component } from '@angular/core';

interface Language {
  id: string;
  name: string;
  code: string;
  imageUrl: string;
}

interface Country {
  id: number;
  name: string;
  imageUrl: string;
}

interface Person {
  id: number;
  name: string;
  email: string;
}

@Component({
  selector: 'app-popover-list-selector-showcase',
  templateUrl: './popover-list-selector-showcase.component.html',
  styleUrls: ['./popover-list-selector-showcase.component.scss']
})
export class PopoverListSelectorShowcaseComponent {
  // Language Selection Example
  languages: Language[] = [
    { id: 'en', name: 'English', code: 'EN', imageUrl: 'assets/images/icons/Eng.png' },
    { id: 'kr', name: '한국어', code: 'KR', imageUrl: 'assets/images/icons/koria-flag.jpeg' },
    { id: 'jp', name: '日本語', code: 'JP', imageUrl: 'assets/images/icons/Japan-Flag.png' }
  ];
  selectedLanguage: Language | null = this.languages[0];

  // Country Selection Example
  countries: Country[] = [
    { id: 1, name: 'United Kingdom', imageUrl: 'assets/images/icons/Eng.png' },
    { id: 2, name: 'South Korea', imageUrl: 'assets/images/icons/koria-flag.jpeg' },
    { id: 3, name: 'Japan', imageUrl: 'assets/images/icons/Japan-Flag.png' }
  ];
  selectedCountry: Country | null = null;

  // User Selection Example
  users: Person[] = [
    { id: 1, name: '👤 John Doe', email: 'john@example.com' },
    { id: 2, name: '👩 Jane Smith', email: 'jane@example.com' },
    { id: 3, name: '👨 Bob Johnson', email: 'bob@example.com' }
  ];
  selectedUser: Person | null = null;

  // Simple String Array Example
  simpleItems: string[] = ['✓ Option 1', '⚙️ Option 2', '📝 Option 3', '🔔 Option 4'];
  selectedSimpleItem: string | null = null;

  onLanguageSelected(language: Language): void {
    this.selectedLanguage = language;
  }

  onCountrySelected(country: Country): void {
    this.selectedCountry = country;
  }

  onUserSelected(user: Person): void {
    this.selectedUser = user;
  }

  onSimpleItemSelected(item: string): void {
    this.selectedSimpleItem = item;
  }

  resetLanguage(): void {
    this.selectedLanguage = null;
  }

  resetCountry(): void {
    this.selectedCountry = null;
  }

  resetUser(): void {
    this.selectedUser = null;
  }

  resetSimpleItem(): void {
    this.selectedSimpleItem = null;
  }
}
